<template>
  <div class="container-main-body">
    <div style="position: relative; width: 30%; height: 100%; float: left; padding-top: 5px;">
      <div style="height: 30px;">
        <el-button v-if="role_name === '超级权限' || role_name === '软件管理'" type="primary" size="mini" icon="el-icon-plus" @click="addCategoryHandler">新增样本册分类</el-button>
        <el-button type="success" size="mini" icon="el-icon-refresh" @click="loadData">刷新</el-button>
      </div>
      <div style="position: absolute; top: 35px; right: 5px; bottom: 5px; left: 0;">
        <el-table size="mini" ref="categoryTable" :data="categories" style="width: 100%" height="100%" border header-row-class-name="list-header-row" row-class-name="list-row" highlight-current-row row-key="id" :tree-props="{children: 'children'}" @selection-change="handlerCategorySelectionChange" @current-change="handlerChangeCategory">
          <el-table-column type="selection" width="39" align="center"></el-table-column>
          <el-table-column prop="name" label="类别名称" width="90" align="center"></el-table-column>
          <el-table-column prop="code" label="类别编码" width="90" align="center"></el-table-column>
          <el-table-column prop="remark" label="备注" header-align="center"></el-table-column>
          <el-table-column v-if="role_name === '超级权限' || role_name === '软件管理'" label="操作" width="90" align="center">
            <template v-slot:default="scope">
              <el-button type="primary" size="mini" circle icon="el-icon-edit" @click="editCategoryHandler(scope.row)"></el-button>
              <el-button type="danger" size="mini" circle icon="el-icon-minus" @click="delCategoryHandler(scope.row)"></el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div style="position: relative; width: 70%; height: 100%; float: right; padding-top: 5px;">
      <div v-if="currentCategory !== null" style="height: 30px; font-size: 12px;">
        <span style="margin-left: 10px; font-weight: bold;">搜索</span>
        <span style="margin-left: 20px;">样本册名称：</span>
        <el-input size="mini" v-model="query.productName" placeholder="请输样本册名称" style="width: 140px;" clearable></el-input>
        <!-- <span style="margin-left: 20px;">版本年份：</span>
        <el-input size="mini" v-model="query.yearStart" placeholder="起始年份" style="width: 80px;"></el-input>
        -
        <el-input size="mini" v-model="query.yearEnd" placeholder="结束年份" style="width: 80px;"></el-input>
        <span style="margin-left: 20px;">增刷版本：</span>
        <el-input size="mini" v-model="query.versionNumber" placeholder="输入版本" style="width: 80px; margin-right: 10px;"></el-input> -->
        <el-button type="primary" size="mini" icon="el-icon-search" plain round @click="handlerSearchProducts">搜索</el-button>
        <div style="float: right; height: 28px; line-height: 28px;">
          <el-button v-if="role_name === '超级权限' || role_name === '软件管理'" type="primary" size="mini" icon="el-icon-plus" @click="addHandler">新增样本册</el-button>
          <!-- <el-button type="warning" size="mini" icon="el-icon-connection" @click="addHandler">批量移动样本册</el-button> -->
          <el-button v-if="role_name === '超级权限' || role_name === '软件管理'" type="danger" size="mini" icon="el-icon-minus" @click="delHandler">批量删除样本册</el-button>
          <el-button type="success" size="mini" icon="el-icon-refresh" @click="loadProducts">刷新</el-button>
        </div>
      </div>
      <div style="position: absolute; top: 35px; right: 0; bottom: 38px; left: 0;">
        <el-table size="mini" :data="currentCategory.products" style="width: 100%" height="100%" header-row-class-name="list-header-row" row-class-name="list-row" border @selection-change="handlerProductSelectionChange">
          <el-table-column type="selection" width="39" align="center"></el-table-column>
          <el-table-column prop="name" label="样本册名称" width="200" header-align="center"></el-table-column>
          <el-table-column prop="book_number" label="册数" width="74" align="center"></el-table-column>
          <el-table-column prop="version_year" label="版本年份" width="74" align="center"></el-table-column>
          <el-table-column prop="printing_version_number" label="增刷版本" width="74" align="center"></el-table-column>
          <el-table-column prop="remark" label="备注" header-align="center"></el-table-column>
          <el-table-column label="操作" width="90" align="center">
            <template v-slot:default="scope">
              <el-button type="success" size="mini" circle icon="el-icon-share" @click="handlerShare(scope.row)"></el-button>
              <el-button type="warning" size="mini" circle icon="el-icon-view" @click="handlerView(scope.row)"></el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination-container">
        <el-pagination background :current-page="query.pn" :page-size="query.pageSize" :total="query.totalCount" :page-sizes="[10, 15, 20, 25, 30, 50, 100]" layout="total, sizes, prev, pager, next, jumper" @size-change="pageSizeChange" @current-change="pageChange"></el-pagination>
      </div>
    </div>
    <ezz-dialog-form ref="DForm" :parent="this" />
    <ezz-category-dialog-form ref="CForm" :parent="this" />
    <ezz-share-dialog-form ref="SForm" :parent="this" />
  </div>
</template>
<script>
import EzzCategoryDialogForm from '@/views/modules/product/CategoryForm.vue'
import EzzDialogForm from '@/views/modules/product/Form.vue'
import EzzShareDialogForm from '@/views/modules/product/DialogShare.vue'
export default {
  data: function () {
    return {
      queryCategory: {
        pn: 1, // 页码
        pageSize: 20, // 每页条数
        totalCount: 0 // 数据总条数
      },
      query: {
        categoryId: '',
        productName: '',
        yearStart: '',
        yearEnd: '',
        versionNumber: '',
        pn: 1, // 页码
        pageSize: 20, // 每页条数
        totalCount: 0 // 数据总条数
      },
      categories: [],
      selectedCategoryIds: [],
      selectedIds: [],
      currentCategory: {
        products: []
      },
      operator_id: sessionStorage.getItem('operator_id'),
      role_name: sessionStorage.getItem('role_name')
    }
  },
  created: function () {
  },
  mounted: function () {
    this.loadData()
  },
  methods: {
    // 加载数据
    loadData: function () {
      const _this = this
      _this.post(_this.$apis.getProductCategories, _this.queryCategory, function (res) {
        const _json = res.data
        if (_json.status && _json.status === 'logout') {
          window.location.hash = '/'
        } else {
          _this.categories = _json.dataList
          if (_this.categories.length > 0) {
            _this.$refs.categoryTable.setCurrentRow(_this.categories[0])
          } else {
            _this.currentCategory.products = []
          }
        }
      })
    },
    loadProducts: function () {
      const _this = this
      _this.query.categoryId = _this.currentCategory.id
      _this.post(_this.$apis.getProducts, _this.query, function (res) {
        let _json = res.data
        if (_json.status && _json.status === 'logout') {
          window.location.hash = '/'
        } else {
          _this.currentCategory.products = _json.dataList
          _this.query.totalCount = _json.totalCount
          _this.query.pageSize = _json.pageSize
          _this.query.pn = _json.pn
          _this.$forceUpdate()
        }
      })
    },
    // 新增样本册类别
    addCategoryHandler: function () {
      this.$refs.CForm.addHandler()
    },
    editCategoryHandler: function (_row) {
      this.$refs.CForm.editHandler(_row.id)
    },
    // 删除样本册类别
    delCategoryHandler: function (_row) {
      const _this = this
      _this.$confirm('此操作将永久删除该条数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let _params = {
          id: _row.id,
          operator_id: _this.operator_id
        }
        // ajax提交至服务器，删除数据
        _this.post(_this.$apis.delProductCategories, _params, function (res) {
          let _json = res.data
          if (_json.status && _json.status === 'logout') {
            _this.logout()
          } else {
            if (_json.status === 'ok') {
              _this.loadData()
              _this.$message({
                type: 'success',
                message: '删除成功!'
              })
            } else {
              _this.$message({
                type: 'error',
                message: '无数据更新!'
              })
            }
          }
        })
      }).catch(() => {
        _this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    // 样本册类别 行选择事件
    handlerChangeCategory: function (_newRow, _oldRow) {
      this.currentCategory = _newRow
      this.loadProducts()
    },
    // 样本册类别 checkbox选择事件
    handlerCategorySelectionChange: function (selection) {
      this.selectedCategoryIds = []
      for (let _i = 0; _i < selection.length; ++_i) {
        this.selectedCategoryIds.push(selection[_i].id)
      }
    },
    handlerSearchProducts: function () {
      this.loadProducts()
    },
    /**********************************************/
    // 新增样本册
    addHandler: function () {
      this.$refs.DForm.handlerAdd(this.currentCategory.id)
    },
    // 查看关联样本册出入库汇总
    handlerShare: function (_row) {
      this.$refs.SForm.handlerShare(_row.id)
    },
    handlerView: function (_row) {
      this.$refs.DForm.handlerView(_row.id)
    },
    delHandler: function () {
      const _this = this
      let _ids = _this.selectedIds.join(',')

      if (_ids.length === 0) {
        _this.$message({
          type: 'warning',
          message: '至少选择一条数据'
        })
      } else {
        _this.$confirm('此操作将永久删除该条数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let _params = {
            ids: _ids,
            operator_id: _this.operator_id
          }
          // ajax提交至服务器，删除数据
          _this.post(_this.$apis.delProducts, _params, function (res) {
            let _json = res.data
            if (_json.status && _json.status === 'logout') {
              _this.logout()
            } else {
              if (_json.status === 'ok') {
                _this.$message({
                  type: 'success',
                  message: '删除成功!'
                })
                _this.loadProducts()
              } else {
                _this.$message({
                  type: 'error',
                  message: '无数据更新!'
                })
              }
            }
          })
        }).catch(() => {
          _this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      }
    },
    // 多选样本册事件
    handlerProductSelectionChange: function (selection) {
      this.selectedIds = []
      for (let _i = 0; _i < selection.length; ++_i) {
        this.selectedIds.push(selection[_i].id)
      }
    },
    pageChange: function (pn) {
      this.query.pn = pn
      this.loadProducts()
    },
    pageSizeChange: function (pageSize) {
      this.query.pn = 1
      this.query.pageSize = pageSize
      this.loadProducts()
    },
    // 刷新事件
    refreshHandler: function () {
      this.loadProducts()
    }
  },
  components: {
    EzzDialogForm,
    EzzCategoryDialogForm,
    EzzShareDialogForm
  }
}
</script>
